import upperFirst from 'lodash/upperFirst';
import isArray from 'lodash/isArray';
import isObject from 'lodash/isObject';
import pullAll from 'lodash/pullAll';
import uniq from 'lodash/uniq';
import cloneDeep from 'lodash/cloneDeep';

export function ticketSaleOpen(game) {
    const now = new Date().getTime();
    const start = game && game.startAt != null ? new Date(game.startAt).getTime() : null;
    let mayBuyTicketsUntil =
        game.mayBuyTicketsUntil.endsWith('+0000') || game.mayBuyTicketsUntil.endsWith('+00:00')
            ? game.mayBuyTicketsUntil
            : game.mayBuyTicketsUntil + '+0000';
    const expiration = new Date(mayBuyTicketsUntil).getTime();

    if (start) return now >= start && now <= expiration;
    return now <= expiration;
}

export function resolveEditorParentRequiredData(childEditorMetadata, prefixKeys = []) {
    const __editor = cloneDeep(childEditorMetadata);

    if (__editor && __editor.requiredData) {
        __editor.requiredData = pullAll(__editor.requiredData, prefixKeys);
        prefixKeys.forEach(key => {
            __editor.requiredData.push(`parent${upperFirst(key)}`);
        });
        __editor.requiredData = uniq(__editor.requiredData);
    }

    return __editor;
}

function resolveDefaultValue(value) {
    if (isArray(value)) return [];
    if (isObject(value)) return {};
}

export function resolveParentProps(childProps, prefixKeys = []) {
    const parentProps = cloneDeep(childProps);

    prefixKeys.forEach(key => {
        let original = parentProps[key];

        if (original) {
            original.required = false;
            if (original.type && !original.default) {
                original.default = function() {
                    return resolveDefaultValue(original.type());
                };
            }
            parentProps[`parent${upperFirst(key)}`] = original;

            delete parentProps[key];
        }
    });

    return parentProps;
}

export function resolveParentPropValues(component, props = {}, prefixKeys = []) {
    let parentProps = {};
    Object.keys(props).forEach(prop => {
        const key = prefixKeys.includes(prop) ? `parent${upperFirst(prop)}` : prop;
        parentProps[prop] = key in component ? component[key] : undefined;
    });
    return parentProps;
}
